const ngAnalytics = ['$google', function ($google) {
    return {
        scope: {
            ngAnalytics: '=',
        },

        link: function (scope, element) {
            if (!scope.ngAnalytics) {
                return false;
            }
            let handler = ('ontouchstart' in document.documentElement ? "touchstart" : "click");
            // Handle click or touch
            element[0].addEventListener(handler, function (event) {
                var params = scope.ngAnalytics;
                $google.gtag('event', params[0], {
                    'event_category': params[1],
                    'event_label': params[2],
                    'value': params[3],
                });
            }, { passive: true });

        }
    }
}];

export default ngAnalytics;
